/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import { Movement } from './movement';
import { Train }    from './train';
import { StopConsist } from '@/models/scenario/stop.consist';

/**
 *
 * @class MovementHistory
 *
 * @brief each train has a series of movements it made on the rail network during the simulation.  These
 * movements together are the "string line" for the train.  The string viewer allows users to view all the
 * string lines (trains) at once.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2019
 *
 */
export class MovementHistory {

  /** @var _train the train this movement history is for */
  public    _train: Train|null = null;

  /** @var _tMin the minimum time point for this train */
  public     _tMin: number     = 99999999;

  /** @var _tMax the minimum time point for this train */
  public     _tMax: number     = 0;

  /** @var _dMin the minimum distance location for this train */
  public     _dMin: number     = 99999999;

  /** @var _dMax the maximum distance location for this train */
  public     _dMax: number     = 0;

  /** @var _history the start to finish sequence of movements the train made */
  public  _history: Movement[] = [];

  /** the consist changes (for this train) indexed by movement */
  public _consistChanges: {move: Movement, consist: StopConsist}[] = [];

  /** @var _totalDelay sum of all delay for this movement history */
  public _totalDelay: number   = 0;

  /** how many movements have been added so far */
  public _nth: number          = 0;

  /** @brief standard constructor */
  constructor(train: Train) {

    this._train = train;
  }

  /** fetch the very first move if there is one. */
  first(): Movement|null {

    /*
     * the moves are sorted by datapoint_id, and the simulator emits those increasing ids, in the exact
     * order in which they are generated. We want the move with the lowest datapoint_id
     *
     */

    if (this._history.length == 0) {

      return null;
    }

    return this._history[0];
  }

  /** fetch the very last move if there is one. */
  last(): Movement|null {


    /*
     * the moves are sorted by datapoint_id, and the simulator emits those increasing ids, in the exact
     * order in which they are generated. We want the move with the highest datapoint_id
     *
     */

    if (this._history.length == 0) {

      return null;
    }

    return this._history[this._history.length - 1];
  }

  /** @brief add the movement to this train's movement history */
  add(move: Movement) {

    move._nth = this._nth++;

    /* update the bounding rect for this train */

    if (move._arrival < this._tMin) {
      this._tMin = move._arrival;
    }

    if (move._departure > this._tMax) {
      this._tMax = move._departure;
    }

    if (move._dp && move._dp._mileage < this._dMin) {

      this._dMin = move._dp._mileage;
    }

    if (move._dp && move._dp._mileage > this._dMax) {

      this._dMax = move._dp._mileage;
    }

    /* update the history */

    this._history.push(move);
  }

}
